<template>
  <AppIntersectionObserver
      @intersect="onIntersect"
      :options="intersectionOptions"
      class="grid-block">
    <AppLayoutContainerFull :flush="true" class="grid-block__layout-container-full">
      <AppHeadingTitleSubtitle :title="props.data.title" :subtitle="props.data.subtitle" :styling="props.data.styling"/>
    </AppLayoutContainerFull>
    <div class="grid-block__skeleton">
      <AppGridSwiper
          v-show="state.slides && state.slides.length !== 0"
          :slides="state.slides"
          variant="custom"
          :filters="filters"
          :tags="tags"
      />
      <AppLoadingIndicator
          v-show="!state.slides"
          class="grid-block__loader"
      />
    </div>

  </AppIntersectionObserver>
</template>

<script setup lang="ts">
import {TGridBlock} from '~/types/block-types'
import {TGridBlockFilter} from "~/types/grid-block-types";
import {useGetGridData} from "~/composables/useGetGridData";
import {computed} from "vue";
import {sanitizeMarkedHeading} from "~/utils/data-transformers";

const props = defineProps<{
  data: TGridBlock,
}>()

const state = reactive({
  slides: undefined
})

const intersectionOptions = {
  threshold: '0.025'
}

// create the filter query based on the belong_to M2As
const filters = computed((): TGridBlockFilter[] => {
  const obj: TGridBlockFilter[] = []

  props.data.related_to.forEach((relation) => {
    if (relation.item) {
      obj.push({collection: relation.collection, id: relation.item?.id})
    }
  })

  return obj
})

const tags = computed(() => {
  if (props.data.related_to.length > 0) {
    return props.data.related_to.map(item => sanitizeMarkedHeading(item.item?.title))
  }
})

const onIntersect = (data) => {
  if (data.visible && !state.slides) {
    useGetGridData('custom', filters.value).then((response) => {
      state.slides = response.slides.value
    }).catch((error) => {
      throw new Error(error.value?.message)
    })
  }
}
</script>

<style scoped lang="postcss">
.grid-block {
  @mixin app-block-margins;

  &__layout-container-full {
    margin-bottom: 1.5rem;
    overflow: clip;
  }

  &__skeleton {
    width: 100%;
    overflow: clip;
    position: relative;
    min-height: 640px;
    transition: height 250ms linear;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
